import React, { useEffect, useRef } from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getActiveLang, withLang } from '../utils/language';
import * as types from "../redux/actions/CMSData";

function TermsConditionsPage() {

  const isMounted = useRef(true);
  const dispatch = useDispatch();
  let CMSData = useSelector((state) => state.cmsdatadetail.cmsdatadetail);
  const TermsData = CMSData?.term_and_condition || {};
  const selectedLanguage = getActiveLang();

  useEffect(() => {
    if (isMounted.current) {
      if (!CMSData || CMSData.length === 0) {
        dispatch({ type: types.FETCH_CMSDATA_REQUEST });
      }
      isMounted.current = false;
    }
  }, [dispatch]);

  const getContent = () => {
    if (selectedLanguage === 'ori') {
      return {
        otherDetails: TermsData?.other_details_ori,
      };
    } else {
      return {
        otherDetails: TermsData?.other_details_en,
      };
    }
  };

  return (
    <>
      <div className='innerPages'>
        <Container>
          <Row>
            <Col sm={12}>
              <h2>
                <span>
                  {selectedLanguage === 'ori' ? "ନିୟମାବଳୀ " : "Terms & Conditions "}
                </span>
              </h2>
              {/* <h2>Terms &  <span>Conditions</span></h2> */}
              <ul>
                <li>
                  <Link to={withLang('/')}>
                    {selectedLanguage === 'ori' ? "ହୋମ୍" : "Home"}
                  </Link>
                </li>
                <li>/</li>
                <li><strong>
                  {selectedLanguage === 'ori' ? "ନିୟମାବଳୀ" : "Terms & Conditions"}
                </strong></li>
              </ul>
            </Col>
          </Row>
        </Container>
      </div>

      <div className='aboutSection'>
        <Container>
          <Row className='d-flex align-items-center'>
            <div className="col-md-2"></div>
            <div className="col-md-8">
              <p className='text-justify ck-editor-text' dangerouslySetInnerHTML={{ __html: getContent().otherDetails }}></p>
            </div>
            <div className="col-md-2"></div>
            {/* <Col sm={12} className='mt-3'>
              <strong>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy.</strong>
              <p>Text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.</p>
              <p>Text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing.</p>
            </Col> */}
          </Row>
        </Container>
      </div>
    </>
  )
}

export default TermsConditionsPage